export default {
    ariaBack: 'Go to previous',
};
